import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { HelpService, TIPS_STEPS } from '../services/help.service';

// export enum TIPS_STEPS {
//   NONE = -1,
//   PDF_ZOOM = 0,
//   BOOK_PAGE = 2,
//   BOOK_VISOR = 3,
//   BOOK_VISOR_INFO = 4,
//   BOOK_VISOR_SERIES_GRID = 5,
//   BOOK_ZOOM = 6,
// }



@Component({
  selector: 'app-floating-tips',
  templateUrl: './floating-tips.component.html',
  styleUrls: ['./floating-tips.component.css']
})
export class FloatingTipsComponent implements OnInit {

  TIPS_STEPS = TIPS_STEPS;
  get currentStep() {
    return this.helpService?.currentStep;
  }
  get currentStepIndex() {
    return this.helpService?.currentStepIndex;
  }
  get hasNext() {
    return this.helpService?.hasNext;
  }
  get hasPrev() {
    return this.helpService?.hasPrev;
  }
  get stepsLength() {
    return this.helpService?.stepsToShow?.length
  }

  constructor(private helpService: HelpService) { }

  ngOnInit(): void {
  }

  onClose() {
    this.helpService.onClose();
  }

  onPrev() {
    this.helpService.onPrev();
  }

  onNext() {
    this.helpService.onNext();
  }

}
